import {useCallback, useRef} from 'react';
import {useAppSelector} from "./redux";
import {initialProfileLenta} from "../store/reducers/AuthSlice";

export function useUserSettings(){
    const profile = useAppSelector(state => state.auth.profile_lenta);
    const settings = profile.find(item => item.name === 'main') || initialProfileLenta;

    return settings.value;
}